import { memo } from 'react'
import styled from 'styled-components'

import { _M_Medium, mainColors } from '@avantstay/backoffice-core'

import medias from '@styles/medias'

const DEFAULT_SIZE = '40px'

interface AvatarProps {
  size?: string
  src?: string
  color?: string
  backgroundColor?: string
}

export const getAvatarInitials = (name: string) =>
  name
    .split(' ', 2)
    .map(n => n[0])
    .join('')
    .toUpperCase()

const Avatar = styled.div.attrs<AvatarProps>(props => ({
  style: props.src ? { backgroundImage: `url(${props.src})` } : undefined,
}))`
  border-radius: 50%;
  background: ${props => props.backgroundColor ?? mainColors.accentExtremelyLight};
  background-size: cover;
  color: ${props => props.color ?? mainColors.accentMedium};
  display: flex;
  align-items: center;
  justify-content: center;
  ${_M_Medium};

  width: ${props => props.size ?? DEFAULT_SIZE};
  min-width: ${props => props.size ?? DEFAULT_SIZE};
  min-height: ${props => props.size ?? DEFAULT_SIZE};
  height: ${props => props.size ?? DEFAULT_SIZE};

  &:hover {
    cursor: pointer;
  }

  ${medias.MD_SCREEN`
    &:hover {
      cursor: inherit;
    }
  `}
`

export default memo(Avatar)
